<!-- Shared inline icons — no Font Awesome required -->
<template>
  <svg
    v-if="name === 'envelope'"
    class="gcsa-icon"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="3.5"
      y="6"
      width="17"
      height="12"
      rx="1.5"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M4 7.5 L12 13 L20 7.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="name === 'arrow-right'"
    class="gcsa-icon"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5 12 H19"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
    />
    <path
      d="M13 6 L19 12 L13 18"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="name === 'telegram'"
    class="gcsa-icon"
    viewBox="0 0 496 512"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M248 8C111.033 8 0 119.033 0 256s111.033 248 248 248 248-111.033 248-248S384.967 8 248 8Zm114.124 169.232-40.48 190.759c-3.055 13.591-11.041 16.927-22.369 10.541l-61.616-45.462-29.72 28.572c-3.287 3.287-6.045 6.045-12.39 6.045l4.423-62.742 114.114-103.007c4.963-4.423-1.082-6.879-7.719-2.456l-141.027 88.812-60.657-18.947c-13.183-4.127-13.434-13.183 2.757-19.528l237.837-91.714c11.041-4.127 20.734 2.436 17.131 19.127Z"
    />
  </svg>
  <svg
    v-else-if="name === 'x'"
    class="gcsa-icon"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  name: 'envelope' | 'arrow-right' | 'telegram' | 'x';
}>();
</script>

<style scoped>
.gcsa-icon {
  display: block;
  width: 1em;
  height: 1em;
  flex-shrink: 0;
}
</style>
